var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79999 20.4272C5.79999 20.4272 -0.0404024 36.6505 10.3691 35.21C20.7785 33.7695 35.9869 44.9436 37.6576 31.3342C39.3302 17.7248 36.7894 5.37545 31.4178 4.11361C26.0462 2.85178 12.6436 -0.277939 5.79999 20.4272Z",
    fill: "#B49D70",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 32C15.433 32 17 30.433 17 28.5C17 26.567 15.433 25 13.5 25C11.567 25 10 26.567 10 28.5C10 30.433 11.567 32 13.5 32Z",
    stroke: "url(#paint0_linear_1786_44802)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14L15 19",
    stroke: "url(#paint1_linear_1786_44802)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14L10 19",
    stroke: "url(#paint2_linear_1786_44802)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 26L32 31",
    stroke: "url(#paint3_linear_1786_44802)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 26L27 31",
    stroke: "url(#paint4_linear_1786_44802)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15V10H27",
    stroke: "url(#paint5_linear_1786_44802)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10L24 12C29 17 25 23 21 24",
    stroke: "url(#paint6_linear_1786_44802)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1786_44802",
    x1: 10,
    y1: 25,
    x2: 16.9994,
    y2: 32.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1786_44802",
    x1: 10,
    y1: 14,
    x2: 14.9995,
    y2: 19.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1786_44802",
    x1: 10,
    y1: 14,
    x2: 14.9995,
    y2: 19.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1786_44802",
    x1: 27,
    y1: 26,
    x2: 31.9995,
    y2: 31.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1786_44802",
    x1: 27,
    y1: 26,
    x2: 31.9995,
    y2: 31.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1786_44802",
    x1: 22,
    y1: 10,
    x2: 26.9995,
    y2: 15.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1786_44802",
    x1: 21,
    y1: 10,
    x2: 30.3153,
    y2: 13.5493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoach);
export default __webpack_public_path__ + "static/media/Coach.ca46bb4e26ea208e9ffda31962cc3582.svg";
export { ForwardRef as ReactComponent };